module.exports = __webpack_public_path__ + "static/media/31.3a673411.png";